import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { WBBox } from '@admiin-com/ds-web';
import { useCurrentEntityId } from '../../../hooks/useSelectedEntity/useSelectedEntity';
import AutoCompleteLookupV2 from '../../../components/AutoCompleteLookup/AutoCompleteLookupV2';

interface ClientPartnerManagerFormProps {
  entityIndex?: number;
}

export const ClientPartnerManagerForm = ({
  entityIndex,
}: ClientPartnerManagerFormProps) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const entityId = useCurrentEntityId();

  // Use the entityIndex to build the correct field names
  const partnerFieldName =
    entityIndex !== undefined ? `entities.${entityIndex}.partner` : 'partner';
  const managerFieldName =
    entityIndex !== undefined ? `entities.${entityIndex}.manager` : 'manager';

  return (
    <>
      <WBBox mt={3}>
        <Controller
          name={partnerFieldName}
          control={control}
          render={({ field }) => (
            <AutoCompleteLookupV2
              type="ClientPartner"
              entityId={entityId}
              value={field.value}
              onChange={field.onChange}
              label={t('partner', { ns: 'clients', defaultValue: 'Partner' })}
              placeholder={t('searchUser', {
                ns: 'users',
                defaultValue: 'Search for a user',
              })}
              noPopupIcon
            />
          )}
        />
      </WBBox>

      <WBBox mt={2}>
        <Controller
          name={managerFieldName}
          control={control}
          render={({ field }) => (
            <AutoCompleteLookupV2
              type="ClientManager"
              entityId={entityId}
              value={field.value}
              onChange={field.onChange}
              label={t('manager', { ns: 'clients', defaultValue: 'Manager' })}
              placeholder={t('searchUser', {
                ns: 'users',
                defaultValue: 'Search for a user',
              })}
              noPopupIcon
            />
          )}
        />
      </WBBox>
    </>
  );
};
